module.exports = __webpack_public_path__ + "media/smart_sales/benefit-2-ba4efee8.webp";